import React from 'react';

const PlaceholderView = ({ title, icon: Icon }) => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6 text-gray-800">{title}</h2>
      <div className="rounded-lg shadow p-12 text-center bg-white">
        <Icon size={64} className="mx-auto mb-4 text-gray-400" />
        <h3 className="text-xl font-semibold mb-2 text-gray-600">Módulo en Desarrollo</h3>
        <p className="text-gray-500">Esta funcionalidad estará disponible próximamente</p>
      </div>
    </div>
  );
};

export default PlaceholderView;
